function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import axios from 'axios';
import { NotInitializedError } from '../../error/error';
/**@example https://example.com */ export class MauthHttpClient {
    get instance() {
        if (!this._instance) {
            throw NotInitializedError;
        }
        return this._instance;
    }
    init(option) {
        var _option_lang, _option_version;
        this._instance = axios.create({
            baseURL: option.host + "/".concat((_option_lang = option.lang) !== null && _option_lang !== void 0 ? _option_lang : 'kr', "/api/public/v").concat((_option_version = option.version) !== null && _option_version !== void 0 ? _option_version : 1),
            params: {
                client_id: option.client_id
            },
            headers: {
                'client-id': option.client_id
            },
            withCredentials: true
        });
    }
    // 쿠키를 포함
    async sessionCheck() {
        const { data } = await this.instance.get('/user/session_check', {});
        return data;
    }
    constructor(){
        _define_property(this, "_instance", void 0);
    }
}
